<template>
    <div>
        <el-card class="box-card">
            <!-- 查询 start -->
            <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="70px">
                <el-form-item label="操作反馈">
                    <el-select v-model="keywords.controlback" placeholder="请选择" class="select">
                        <el-option label="所有回馈" value="0X00"></el-option>
                        <el-option label="自检错误回馈" value="0X7D"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="">
                    <el-select v-model="keywords.timetype" placeholder="请选择" class="select">
                        <el-option label="采集时间" value="1"></el-option>
                        <el-option label="入库时间" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-date-picker v-model="keywords.begintime" type="date" value-format="yyyy-MM-dd" placeholder="开始时间" class="mr15"></el-date-picker>
                <el-date-picker v-model="keywords.endtime" type="date" value-format="yyyy-MM-dd" placeholder="结束时间" class="mr15"></el-date-picker>
                <el-form-item>
                    <el-button type="primary" @click="clicksearch">查询</el-button>
                    <el-button type="info" @click="backDataCollection">返回</el-button>
                </el-form-item>
            </el-form>
            <!-- 查询 end -->

            <!-- 列表 -->
            <el-table :data="dataList" border stripe>
                <el-table-column prop="Mac" label="MAC地址" width="150px"></el-table-column>
                <el-table-column prop="Name" label="会员名称"  width="100px"></el-table-column>
                <el-table-column prop="Dataproperty" label="操作反馈"></el-table-column>
                <el-table-column prop="Leftdegree" label="左眼屈光度" width="100px"></el-table-column>
                <el-table-column prop="Leftdegree" label="右眼屈光度" width="100px"></el-table-column>
                <el-table-column prop="Upperlimit" label="区间上限" width="100px" v-if="SubRule_Customer_DataCollectionQuJian"></el-table-column>
                <el-table-column prop="Lowerlimit" label="区间下限" width="100px" v-if="SubRule_Customer_DataCollectionQuJian"></el-table-column>
                <el-table-column prop="Frequency" label="移动次数" width="100px"></el-table-column>
                <el-table-column prop="Speed" label="移动速度" width="100px"></el-table-column>
                <el-table-column prop="Ranging" label="距离(mm)" width="100px"></el-table-column>
                <el-table-column prop="Caijitimep" label="采集时间"></el-table-column>
                <el-table-column prop="Createtime" label="入库时间"></el-table-column>
                <el-table-column prop="Rightdegree" label="测试" width="60px"></el-table-column>
            </el-table>

            <!-- 分页 -->
            <div class="pages">
              <el-pagination
                @current-change="handleCurrentPageChange"
                :page-size="10"
                layout="total, prev, pager, next, jumper"
                :total="dataListnum"
				:current-page.sync="selectedPageNo">
              </el-pagination>
            </div>

        </el-card>
    </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  data () {
    return {
      keywords: {
        controlback: '0X7D',
        timetype: '1',
        begintime: '',
        endtime: ''
      },
      selectedPageNo: 1,
      dataList: [],
      dataListnum: 0,
      SubRule_Customer_DataCollectionQuJian: false,
      parentdata: null
    }
  },
  mounted () {
    var that = this
    Vue.prototype.FunCheckSubRule('SubRule_Customer_DataCollectionQuJian', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_Customer_DataCollectionQuJian = true
      }
    })
  },
  methods: {
    LoadData (parentdata) {
      this.parentdata = parentdata
      this.clicksearch()
    },
    backDataCollection () {
      this.$emit('triggerFunc', '')
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apigetCaijinum()
      this.apigetCaijilist()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apigetCaijilist()
    },
    apigetCaijilist: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        glassuserid: that.parentdata.params.userid,
        pageno: that.selectedPageNo,
        controlback: that.keywords.controlback,
        timetype: that.keywords.timetype,
        begintime: that.keywords.begintime,
        endtime: that.keywords.endtime
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetCaijilist, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apigetCaijinum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        glassuserid: that.parentdata.params.userid,
        controlback: that.keywords.controlback,
        timetype: that.keywords.timetype,
        begintime: that.keywords.begintime,
        endtime: that.keywords.endtime
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetCaijinum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
